import { Route } from '@angular/router';

export const PurchaseOrdersRoute: Route = {
  path: 'purchase-orders',
  loadComponent() {
    return import('@daas-consulting/production/shared/frontend/pages').then(
      (c) => c.LayoutBase2PageComponent
    );
  },
  loadChildren() {
    return import(
      '@daas-consulting/production/shared/frontend/purchase_orders_shell'
    ).then((c) => c.purchaseOrdersShellRoutes);
  },
};
